import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/admin/contactos", label: "Contactos", testid: "admin-tab-contactos" },
  { to: "/admin/reparaciones", label: "Reparaciones", testid: "admin-tab-reparaciones" },
];

export default function AdminTabs() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="admin-tabs"
      className="flex items-center gap-1 border border-white/15 p-1"
      style={{ borderRadius: "2px" }}
    >
      {TABS.map((t) => {
        const active = pathname === t.to;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            className={`px-4 py-1.5 text-xs uppercase tracking-wider font-semibold transition-colors ${
              active ? "bg-[#00B4D8] text-white" : "text-white/60 hover:text-white"
            }`}
            style={{ borderRadius: "2px" }}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
